import useAuth from '../../hooks/useAuth'

const Menu = ({ children }) => {
  return (
    <div className='mt-4 px-4'>
      <div className='flex flex-row gap-4 items-center'>{children}</div>
    </div>
  )
}

export default Menu
